import React, { useEffect, useState } from "react";
import AddTechnicians from "./add_techies";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FiSearch } from "react-icons/fi";

function Technicians(props) {
  const [toggleAdd, setToggleAdd] = useState(false);
  const [techies, setTechies] = useState([]);
  const [editUser, setEditUser] = useState({});
    const [selectedUser, setSelectedUser] = useState('');
  const [showDelete, setShowDelete] = useState(false);
const [searchTerm, setSearchTerm] = useState("");

  function addProductToggler() {
    setToggleAdd(!toggleAdd);
  }

  useEffect(() => {
    const getCompanies = async () => {
      try {
        const storedTechies = localStorage.getItem("techies");

        if (storedTechies) {
          setTechies(JSON.parse(storedTechies));
        } else {
          const response = await axios.get(
            "https://api.dectwinservices.com/api/get-techies"
          );
          setTechies(response.data);
          localStorage.setItem("techies", JSON.stringify(response.data));
        }
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    getCompanies();
  }, [props]);

  const exportToExcel = () => {
    if (!techies || techies.length === 0) {
      console.error("No data to export.");
      return;
    }

    // Define the columns for the Excel file
    // Define the columns for the Excel file
    const formattedData = techies.map((item) => ({
      "Technician Name": item.name,
      "User ID": item.staff_id,
      "Company ID": item.company_id,
      Contact: item.contact,
      Email: item.email,
      // "Assigned Item": item.item_id,
      // "Assigned Date": item.item_assign_date,
      Designation: item.designation,
    }));

    // Create a new worksheet
    const ws = XLSX.utils.json_to_sheet(formattedData);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Technicians");

    // Convert workbook to a binary Excel file
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Create a Blob and trigger download
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `Technicians.xlsx`);
  };

const handleDelUser = (com) => {
setSelectedUser(com);
setShowDelete(true);

}



const handleDelete = async () => {
  try {
    const response = await axios.delete(
      `https://api.dectwinservices.com/api/delete-engineer/${selectedUser.id}`,
      {
        data: {
          item_id: selectedUser.item_id,
        },
      }
    );

    if (response.status === 200) {
      props.handleToast({
        toastMsg: "User Removed Successfully!!!",
        toastColor: "#4CAF50",
      });

      setShowDelete(false);
      window.location.reload();
    } else {
      props.handleToast({
        toastMsg: "Something went wrong!",
        toastColor: "#FF0000",
      });
    }
  } catch (error) {
    console.error("Error deleting user:", error);
    props.handleToast({
      toastMsg: "Something went wrong!",
      toastColor: "#FF0000",
    });
  }
};


const filteredData = techies.filter((p) =>
  p.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  p.contact.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.staff_id.toLowerCase().includes(searchTerm.toLowerCase())
);

  return toggleAdd ? (
    <AddTechnicians
      editUser={editUser}
      toggler={addProductToggler}
      handleToast={props.handleToast}
      handleLoading={props.handleLoading}
      closeLoading={props.closeLoading}
    />
  ) : (
    <section className="px-32">
      <div className="d-md-flex justify-between">
        <div className="d-flex">
          <i className="bx bxs-wrench" style={{ fontSize: "24px" }}></i>
          <p className="fw-bolder fs-big">&nbsp;Engineer's Overview</p>
        </div>
<div className="d-md-flex d-sm-flex">


      <div className="my-2 px-1">   
    <button
            className="add-btn"
            style={{ background: "#00AA00" }}
            onClick={exportToExcel}
          >
            <i className="bx bxs-download" style={{ fontSize: "22px" }}></i>
            &nbsp; Export to Excel
          </button>
        </div>

         <div className="my-2 px-1">   
  <button
            className="add-btn"
            onClick={() => {
              setEditUser({});
              addProductToggler();
            }}
          >
            <i className="bx bxs-plus-circle" style={{ fontSize: "22px" }}></i>
            &nbsp; Add Engineer
          </button>
        </div>
        </div>
      </div>

  <div className="form-data col-md-4 col-12">
      <div className="input-icon bg-white">
        <i className="bx bxs-search"></i>


      <input
        type="text"
        className="p-2"
        placeholder="Search by name"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  </div>

           <div className="bg-white table-responsive rounded-3">
        <table className="table w-100">
                   <thead className="bg-grey">
           
              <th className="p-2">User ID</th>
              <th className="p-2">Engineer Name</th>
              <th className="p-2">Company ID</th>
              <th className="p-2">Company Name</th>
              <th className="p-2">Designation</th>
              <th className="p-2">Email</th>
                <th   className="p-2 text-center">
                <i className="bx bxs-cog rounded-circle bg-grey p-0"></i>
              </th>
          </thead>

              {filteredData.map((com, index) => (
                <tr key={index}>
                  <td className="p-2">{com.staff_id}</td>
                  <td className="p-2">{com.name}</td>
                  <td className="p-2">{com.comp_id}</td>
                  <td className="p-2">{com.company_name}</td>
                  <td className="p-2">{com.designation}</td>
                  <td className="p-2">{com.email}</td>
                  <td className="p-2">
                    <i
                      title="Edit Product"
                      style={{ fontSize: "24px", cursor: "pointer" }}
                      className="bx bxs-edit"
                      onClick={() => {
                        setEditUser(com);
                        addProductToggler();
                      }}
                    ></i>
                       <i
                      title="Delete Product"
                      style={{ fontSize: "24px", cursor: "pointer", color: 'red' }}
                      className="bx bxs-trash"
                      onClick={() => {
                        handleDelUser(com)
                      }}
                    ></i>
                  </td>
                </tr>
              ))}
          </table>

          {showDelete && (
        <>
            <div className="ticket-popup">
      <div className="accept-ticket">

<h4 style={{textAlign: 'center'}}>Really Want to Remove Engineer "{selectedUser.name}"?</h4>
        <div className="btn-group d-flex" style={{ justifyContent: "center" }}>
          <button
            className="add-btn"
            style={{ background: "#ec0e0e" }}
            onClick={() => setShowDelete(false)}
          >
            Go Back
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button className="add-btn" onClick={handleDelete}>
            Remove
          </button>
        </div>

</div>
</div>
        </>
      )}
      </div>
    </section>
  );
}

export default Technicians;
